export default Object.freeze({
  None: 0, // "none"
  Low: 1, // "low"
  Medium: 2, // "medium"
  High: 3, // "high"
  Urgent: 4, // "urgent"
  Critical: 5, // "critical"
});
